import alt from 'components/Dispatcher';
import {Store, StoreMethods} from '@store/@types/alt';
import KpiObservationActions, {
  KpiObservationActionsInterface,
} from '@store/kpi/KpiObservationActions';
import {KpiObservation, KpiRequest, CoachingKpi} from '@store/@types/kpi';
import {List, Map} from 'immutable';
import {Int} from '@store/@types/util';
import {
  ObservationBySkillsRequest,
  ObservationSearchRequest,
} from '@store/kpi/KpiObservationSource';
import {UserId} from 'records/User';

interface KpiObservationStoreState {
  kpiObservations: List<KpiObservation>;
  kpiObservationsByUser: Map<UserId, List<KpiObservation>>;
  totalResults: Int;
  pageSize: Int;
  kpiRequests: List<KpiRequest>;
  kpiRequestsByUser: Map<UserId, List<KpiRequest>>;
  kpiBySkillsObservations: List<KpiObservation>;
  coachingKpisByUser: Map<UserId, List<CoachingKpi>>;
}

class KpiObservationStore
  extends Store<KpiObservationStoreState>
  implements StoreMethods<KpiObservationActionsInterface>
{
  constructor() {
    super();
    this.state = {
      kpiObservations: List(),
      kpiObservationsByUser: Map(),
      totalResults: 1,
      pageSize: 10,
      kpiRequests: List(),
      kpiRequestsByUser: Map(),
      kpiBySkillsObservations: List(),
      coachingKpisByUser: Map(),
    };
    this.bindActions(KpiObservationActions);
  }

  search(params: ObservationSearchRequest): void {
    this.setState({
      pageSize: params.count,
    });
  }
  searchError(error: Error): void {
    console.error(error);
  }
  searchSuccess({
    userId,
    total,
    kpiObservations,
  }: {
    userId: UserId;
    total: Int;
    kpiObservations: List<KpiObservation>;
  }): void {
    this.setState({
      kpiObservations,
      kpiObservationsByUser: this.state.kpiObservationsByUser.set(userId, kpiObservations),
      totalResults: total,
    });
  }

  bySkills(_params: ObservationBySkillsRequest): void {}
  bySkillsError(error: Error): void {
    console.error(error);
  }
  bySkillsSuccess(kpiObservations: List<KpiObservation>): void {
    this.setState({
      kpiBySkillsObservations: kpiObservations.sortBy(o => o.created).sortBy(o => o.id),
    });
  }

  create(params): void {}
  createError(error: Error): void {
    console.error(error);
  }
  createSuccess(): void {}

  update(): void {}
  updateError(error: Error): void {
    console.error(error);
  }
  updateSuccess(): void {}

  getReminders(): void {}
  getRemindersError(error: Error): void {
    console.error(error);
  }
  getRemindersSuccess([kpiRequests, userId]: [List<KpiRequest>, UserId]): void {
    this.setState({
      kpiRequests,
      kpiRequestsByUser: this.state.kpiRequestsByUser.set(userId, kpiRequests),
    });
  }

  coachingKpis(params: ObservationBySkillsRequest): void {}
  coachingKpisError(error: Error): void {
    console.error(error);
  }
  coachingKpisSuccess([coachingKpis, userId]: [List<CoachingKpi>, UserId]): void {
    this.setState({coachingKpisByUser: this.state.coachingKpisByUser.set(userId, coachingKpis)});
  }
}

export default alt.createStore(KpiObservationStore);
